import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Fonction pour récupérer le token de la session active de CET ONGLET
const getActiveSessionToken = () => {
  // Utiliser sessionStorage pour isoler les sessions par onglet
  const currentSessionEmail = sessionStorage.getItem("hb_current_session");
  
  if (currentSessionEmail) {
    // Récupérer le token de la session active de cet onglet
    const tokenKey = `hb_token_${currentSessionEmail}`;
    return localStorage.getItem(tokenKey);
  }
  
  // Compatibilité avec l'ancien système
  return localStorage.getItem("hb_token");
};

api.interceptors.request.use((config) => {
  const token = getActiveSessionToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      // token invalid/expired
      const path = window.location.pathname;
      if (path.startsWith("/dashboard") || path.startsWith("/admin")) {
        const currentSessionEmail = sessionStorage.getItem("hb_current_session");
        
        if (currentSessionEmail) {
          // Supprimer uniquement la session expirée de cet onglet
          const tokenKey = `hb_token_${currentSessionEmail}`;
          const userKey = `hb_user_${currentSessionEmail}`;
          localStorage.removeItem(tokenKey);
          localStorage.removeItem(userKey);
          sessionStorage.removeItem("hb_current_session");
        }
        
        // Compatibilité : supprimer aussi les anciennes clés
        localStorage.removeItem("hb_token");
        localStorage.removeItem("hb_user");
        
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
